import { useState } from 'react';

export default function useLoading(initLoading = false) {
  const [loading, setLoading] = useState(initLoading);
  return {
    loading,
    onFinishLoading: () => setLoading(false),
    onStartLoading: () => setLoading(true),
  };
}
